import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'

import InlineSearch from 'modules/core/components/InlineSearch'

interface Props {
  field: string
  setField: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export default function SearchBar({ field, setField }: Props) {
  return (
    <Box paddingTop="s48" paddingRight="s48" paddingBottom="s24">
      <InlineSearch onSearch={setField} search={field} noBackground />
    </Box>
  )
}
